// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    /*Note [NC]: The below need to be commented as CSS will be taken from Umbraco Project*/
    /* margin: 0;
    font-family: "Source Sans Pro", sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background-color: rgba(246, 246, 246, 0.8);*/
}

code {
    /*font-family: "Source Sans Pro", sans-serif;*/
}
`, "",{"version":3,"sources":["webpack://./__ReactProjects/@frontend/base-ui-user-login/src/index.css"],"names":[],"mappings":"AAAA;IACI,sFAAsF;IACtF;;;;gDAI4C;AAChD;;AAEA;IACI,8CAA8C;AAClD","sourcesContent":["body {\n    /*Note [NC]: The below need to be commented as CSS will be taken from Umbraco Project*/\n    /* margin: 0;\n    font-family: \"Source Sans Pro\", sans-serif;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    background-color: rgba(246, 246, 246, 0.8);*/\n}\n\ncode {\n    /*font-family: \"Source Sans Pro\", sans-serif;*/\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
